// extracted by mini-css-extract-plugin
export default {"imageContainer":"SingleReviewer_imageContainer__kf7lZ","itemContainer":"SingleReviewer_itemContainer__svdiS"};